(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-io-kotlinx-io-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kotlinx-io-kotlinx-io-core'.");
    }
    globalThis['kotlinx-io-kotlinx-io-core'] = factory(typeof globalThis['kotlinx-io-kotlinx-io-core'] === 'undefined' ? {} : globalThis['kotlinx-io-kotlinx-io-core'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.c2;
  var Long = kotlin_kotlin.$_$.rg;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.v1;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.p2;
  var charArrayOf = kotlin_kotlin.$_$.ab;
  var protoOf = kotlin_kotlin.$_$.tc;
  var toString = kotlin_kotlin.$_$.xc;
  var Unit_instance = kotlin_kotlin.$_$.e5;
  var toShort = kotlin_kotlin.$_$.wc;
  var ensureNotNull = kotlin_kotlin.$_$.ph;
  var toLong = kotlin_kotlin.$_$.vc;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.i1;
  var initMetadataForClass = kotlin_kotlin.$_$.qb;
  var VOID = kotlin_kotlin.$_$.i;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.z1;
  var objectCreate = kotlin_kotlin.$_$.sc;
  var initMetadataForCompanion = kotlin_kotlin.$_$.rb;
  var arrayCopy = kotlin_kotlin.$_$.y5;
  var toByte = kotlin_kotlin.$_$.uc;
  var IllegalArgumentException_init_$Create$_0 = kotlin_kotlin.$_$.t1;
  var initMetadataForObject = kotlin_kotlin.$_$.wb;
  var initMetadataForInterface = kotlin_kotlin.$_$.ub;
  var charSequenceGet = kotlin_kotlin.$_$.cb;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.v2;
  var charArray = kotlin_kotlin.$_$.bb;
  var numberToChar = kotlin_kotlin.$_$.oc;
  var concatToString = kotlin_kotlin.$_$.vd;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.p1;
  var captureStack = kotlin_kotlin.$_$.za;
  var Exception_init_$Init$_0 = kotlin_kotlin.$_$.q1;
  var Exception_init_$Init$_1 = kotlin_kotlin.$_$.r1;
  var Exception = kotlin_kotlin.$_$.og;
  //endregion
  //region block: pre-declaration
  initMetadataForInterface(Source, 'Source');
  function write$default(source, startIndex, endIndex, $super) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    endIndex = endIndex === VOID ? source.length : endIndex;
    var tmp;
    if ($super === VOID) {
      this.h4v(source, startIndex, endIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.h4v.call(this, source, startIndex, endIndex);
    }
    return tmp;
  }
  initMetadataForInterface(Sink, 'Sink');
  initMetadataForClass(Buffer, 'Buffer', Buffer, VOID, [Source, Sink]);
  initMetadataForClass(PeekSource, 'PeekSource');
  initMetadataForClass(RealSource, 'RealSource', VOID, VOID, [Source]);
  initMetadataForCompanion(Companion);
  initMetadataForClass(Segment, 'Segment');
  initMetadataForClass(SegmentCopyTracker, 'SegmentCopyTracker');
  initMetadataForObject(AlwaysSharedCopyTracker, 'AlwaysSharedCopyTracker', VOID, SegmentCopyTracker);
  initMetadataForObject(UnsafeBufferOperations, 'UnsafeBufferOperations');
  initMetadataForClass(SegmentReadContextImpl$1);
  initMetadataForClass(SegmentWriteContextImpl$1);
  initMetadataForClass(BufferIterationContextImpl$1);
  initMetadataForClass(IOException, 'IOException', IOException_init_$Create$, Exception);
  initMetadataForClass(EOFException, 'EOFException', EOFException_init_$Create$, IOException);
  initMetadataForObject(SegmentPool, 'SegmentPool');
  //endregion
  function get_HEX_DIGIT_CHARS() {
    _init_properties__Util_kt__g8tcl9();
    return HEX_DIGIT_CHARS;
  }
  var HEX_DIGIT_CHARS;
  function checkBounds(size, startIndex, endIndex) {
    _init_properties__Util_kt__g8tcl9();
    if (startIndex.e1(new Long(0, 0)) < 0 || endIndex.e1(size) > 0) {
      throw IndexOutOfBoundsException_init_$Create$('startIndex (' + startIndex.toString() + ') and endIndex (' + endIndex.toString() + ') are not within the range [0..size(' + size.toString() + '))');
    }
    if (startIndex.e1(endIndex) > 0) {
      throw IllegalArgumentException_init_$Create$('startIndex (' + startIndex.toString() + ') > endIndex (' + endIndex.toString() + ')');
    }
  }
  function checkOffsetAndCount(size, offset, byteCount) {
    _init_properties__Util_kt__g8tcl9();
    if (offset.e1(new Long(0, 0)) < 0 || offset.e1(size) > 0 || size.v2(offset).e1(byteCount) < 0 || byteCount.e1(new Long(0, 0)) < 0) {
      throw IllegalArgumentException_init_$Create$('offset (' + offset.toString() + ') and byteCount (' + byteCount.toString() + ') are not within the range [0..size(' + size.toString() + '))');
    }
  }
  var properties_initialized__Util_kt_67kc5b;
  function _init_properties__Util_kt__g8tcl9() {
    if (!properties_initialized__Util_kt_67kc5b) {
      properties_initialized__Util_kt_67kc5b = true;
      // Inline function 'kotlin.charArrayOf' call
      HEX_DIGIT_CHARS = charArrayOf([_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(49), _Char___init__impl__6a9atx(50), _Char___init__impl__6a9atx(51), _Char___init__impl__6a9atx(52), _Char___init__impl__6a9atx(53), _Char___init__impl__6a9atx(54), _Char___init__impl__6a9atx(55), _Char___init__impl__6a9atx(56), _Char___init__impl__6a9atx(57), _Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(98), _Char___init__impl__6a9atx(99), _Char___init__impl__6a9atx(100), _Char___init__impl__6a9atx(101), _Char___init__impl__6a9atx(102)]);
    }
  }
  function throwEof($this, byteCount) {
    throw EOFException_init_$Create$_0("Buffer doesn't contain required number of bytes (size: " + $this.j().toString() + ', required: ' + byteCount.toString() + ')');
  }
  function Buffer() {
    this.v4t_1 = null;
    this.w4t_1 = null;
    this.x4t_1 = new Long(0, 0);
  }
  protoOf(Buffer).j = function () {
    return this.x4t_1;
  };
  protoOf(Buffer).y4t = function () {
    return this;
  };
  protoOf(Buffer).z4t = function () {
    return this.j().equals(new Long(0, 0));
  };
  protoOf(Buffer).a4u = function (byteCount) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(byteCount.e1(new Long(0, 0)) >= 0)) {
      // Inline function 'kotlinx.io.Buffer.require.<anonymous>' call
      var message = 'byteCount: ' + byteCount.toString();
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    if (this.j().e1(byteCount) < 0) {
      throw EOFException_init_$Create$_0("Buffer doesn't contain required number of bytes (size: " + this.j().toString() + ', required: ' + byteCount.toString() + ')');
    }
  };
  protoOf(Buffer).b4u = function (byteCount) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(byteCount.e1(new Long(0, 0)) >= 0)) {
      // Inline function 'kotlinx.io.Buffer.request.<anonymous>' call
      var message = 'byteCount: ' + byteCount.toString() + ' < 0';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return this.j().e1(byteCount) >= 0;
  };
  protoOf(Buffer).c4u = function () {
    var tmp0_elvis_lhs = this.v4t_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwEof(this, new Long(1, 0));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var segment = tmp;
    var segmentSize = segment.k4u();
    if (segmentSize === 0) {
      this.l4u();
      return this.c4u();
    }
    var v = segment.m4u();
    this.x4t_1 = this.x4t_1.v2(new Long(1, 0));
    if (segmentSize === 1) {
      this.l4u();
    }
    return v;
  };
  protoOf(Buffer).n4u = function () {
    var tmp0_elvis_lhs = this.v4t_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwEof(this, new Long(2, 0));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var segment = tmp;
    var segmentSize = segment.k4u();
    if (segmentSize < 2) {
      this.a4u(new Long(2, 0));
      if (segmentSize === 0) {
        this.l4u();
        return this.n4u();
      }
      // Inline function 'kotlinx.io.and' call
      var tmp_0 = (this.c4u() & 255) << 8;
      // Inline function 'kotlinx.io.and' call
      var tmp$ret$1 = this.c4u() & 255;
      return toShort(tmp_0 | tmp$ret$1);
    }
    var v = segment.o4u();
    this.x4t_1 = this.x4t_1.v2(new Long(2, 0));
    if (segmentSize === 2) {
      this.l4u();
    }
    return v;
  };
  protoOf(Buffer).p4u = function () {
    return Unit_instance;
  };
  protoOf(Buffer).q4u = function (out, startIndex, endIndex) {
    checkBounds(this.j(), startIndex, endIndex);
    if (startIndex.equals(endIndex))
      return Unit_instance;
    var currentOffset = startIndex;
    var remainingByteCount = endIndex.v2(startIndex);
    out.x4t_1 = out.x4t_1.u2(remainingByteCount);
    var s = this.v4t_1;
    while (currentOffset.e1(toLong(ensureNotNull(s).f4u_1 - s.e4u_1 | 0)) >= 0) {
      currentOffset = currentOffset.v2(toLong(s.f4u_1 - s.e4u_1 | 0));
      s = s.i4u_1;
    }
    while (remainingByteCount.e1(new Long(0, 0)) > 0) {
      var copy = ensureNotNull(s).r4u();
      copy.e4u_1 = copy.e4u_1 + currentOffset.g1() | 0;
      var tmp = copy;
      // Inline function 'kotlin.comparisons.minOf' call
      var a = copy.e4u_1 + remainingByteCount.g1() | 0;
      var b = copy.f4u_1;
      tmp.f4u_1 = Math.min(a, b);
      // Inline function 'kotlinx.io.Buffer.pushSegment' call
      if (out.v4t_1 == null) {
        out.v4t_1 = copy;
        out.w4t_1 = copy;
      } else if (false) {
        out.w4t_1 = ensureNotNull(out.w4t_1).s4u(copy).t4u();
        if (ensureNotNull(out.w4t_1).j4u_1 == null) {
          out.v4t_1 = out.w4t_1;
        }
      } else {
        out.w4t_1 = ensureNotNull(out.w4t_1).s4u(copy);
      }
      remainingByteCount = remainingByteCount.v2(toLong(copy.f4u_1 - copy.e4u_1 | 0));
      currentOffset = new Long(0, 0);
      s = s.i4u_1;
    }
  };
  protoOf(Buffer).u4u = function () {
    var result = this.j();
    if (result.equals(new Long(0, 0)))
      return new Long(0, 0);
    var tail = ensureNotNull(this.w4t_1);
    if (tail.f4u_1 < 8192 && tail.h4u_1) {
      result = result.v2(toLong(tail.f4u_1 - tail.e4u_1 | 0));
    }
    return result;
  };
  protoOf(Buffer).g2 = function () {
    return this.v4u(this.j());
  };
  protoOf(Buffer).v4u = function (byteCount) {
    // Inline function 'kotlinx.io.checkByteCount' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(byteCount.e1(new Long(0, 0)) >= 0)) {
      // Inline function 'kotlinx.io.checkByteCount.<anonymous>' call
      var message = 'byteCount (' + byteCount.toString() + ') < 0';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var remainingByteCount = byteCount;
    while (remainingByteCount.e1(new Long(0, 0)) > 0) {
      var tmp0_elvis_lhs = this.v4t_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        throw EOFException_init_$Create$_0('Buffer exhausted before skipping ' + byteCount.toString() + ' bytes.');
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var head = tmp;
      // Inline function 'kotlinx.io.minOf' call
      var a = remainingByteCount;
      var b = head.f4u_1 - head.e4u_1 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var b_0 = toLong(b);
      var toSkip = (a.e1(b_0) <= 0 ? a : b_0).g1();
      this.x4t_1 = this.x4t_1.v2(toLong(toSkip));
      remainingByteCount = remainingByteCount.v2(toLong(toSkip));
      head.e4u_1 = head.e4u_1 + toSkip | 0;
      if (head.e4u_1 === head.f4u_1) {
        this.l4u();
      }
    }
  };
  protoOf(Buffer).w4u = function (sink, startIndex, endIndex) {
    // Inline function 'kotlinx.io.checkBounds' call
    var size = sink.length;
    checkBounds(toLong(size), toLong(startIndex), toLong(endIndex));
    var tmp0_elvis_lhs = this.v4t_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return -1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var s = tmp;
    // Inline function 'kotlin.comparisons.minOf' call
    var a = endIndex - startIndex | 0;
    var b = s.k4u();
    var toCopy = Math.min(a, b);
    s.x4u(sink, startIndex, startIndex + toCopy | 0);
    this.x4t_1 = this.x4t_1.v2(toLong(toCopy));
    if (isEmpty(s)) {
      this.l4u();
    }
    return toCopy;
  };
  protoOf(Buffer).y4u = function (sink, byteCount) {
    // Inline function 'kotlinx.io.checkByteCount' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(byteCount.e1(new Long(0, 0)) >= 0)) {
      // Inline function 'kotlinx.io.checkByteCount.<anonymous>' call
      var message = 'byteCount (' + byteCount.toString() + ') < 0';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    if (this.j().equals(new Long(0, 0)))
      return new Long(-1, -1);
    var bytesWritten = byteCount.e1(this.j()) > 0 ? this.j() : byteCount;
    sink.z4u(this, bytesWritten);
    return bytesWritten;
  };
  protoOf(Buffer).a4v = function (sink, byteCount) {
    // Inline function 'kotlinx.io.checkByteCount' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(byteCount.e1(new Long(0, 0)) >= 0)) {
      // Inline function 'kotlinx.io.checkByteCount.<anonymous>' call
      var message = 'byteCount (' + byteCount.toString() + ') < 0';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    if (this.j().e1(byteCount) < 0) {
      sink.z4u(this, this.j());
      throw EOFException_init_$Create$_0('Buffer exhausted before writing ' + byteCount.toString() + ' bytes. Only ' + this.j().toString() + ' bytes were written.');
    }
    sink.z4u(this, byteCount);
  };
  protoOf(Buffer).b4v = function (sink) {
    var byteCount = this.j();
    if (byteCount.e1(new Long(0, 0)) > 0) {
      sink.z4u(this, byteCount);
    }
    return byteCount;
  };
  protoOf(Buffer).c4v = function () {
    return buffered(new PeekSource(this));
  };
  protoOf(Buffer).d4v = function (minimumCapacity) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
      // Inline function 'kotlinx.io.Buffer.writableSegment.<anonymous>' call
      var message = 'unexpected capacity';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    if (this.w4t_1 == null) {
      var result = SegmentPool_instance.g4v();
      this.v4t_1 = result;
      this.w4t_1 = result;
      return result;
    }
    var t = ensureNotNull(this.w4t_1);
    if ((t.f4u_1 + minimumCapacity | 0) > 8192 || !t.h4u_1) {
      var newTail = t.s4u(SegmentPool_instance.g4v());
      this.w4t_1 = newTail;
      return newTail;
    }
    return t;
  };
  protoOf(Buffer).h4v = function (source, startIndex, endIndex) {
    // Inline function 'kotlinx.io.checkBounds' call
    var size = source.length;
    checkBounds(toLong(size), toLong(startIndex), toLong(endIndex));
    var currentOffset = startIndex;
    while (currentOffset < endIndex) {
      var tail = this.d4v(1);
      // Inline function 'kotlin.comparisons.minOf' call
      var a = endIndex - currentOffset | 0;
      var b = tail.i4v();
      var toCopy = Math.min(a, b);
      tail.j4v(source, currentOffset, currentOffset + toCopy | 0);
      currentOffset = currentOffset + toCopy | 0;
    }
    var tmp = this;
    // Inline function 'kotlin.Long.plus' call
    var this_0 = this.x4t_1;
    var other = endIndex - startIndex | 0;
    tmp.x4t_1 = this_0.u2(toLong(other));
  };
  protoOf(Buffer).z4u = function (source, byteCount) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!(source === this)) {
      // Inline function 'kotlinx.io.Buffer.write.<anonymous>' call
      var message = 'source == this';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    checkOffsetAndCount(source.x4t_1, new Long(0, 0), byteCount);
    var remainingByteCount = byteCount;
    while (remainingByteCount.e1(new Long(0, 0)) > 0) {
      if (remainingByteCount.e1(toLong(ensureNotNull(source.v4t_1).k4u())) < 0) {
        var tail = this.w4t_1;
        var tmp;
        if (!(tail == null) && tail.h4u_1) {
          // Inline function 'kotlin.Long.minus' call
          // Inline function 'kotlin.Long.plus' call
          var this_0 = remainingByteCount;
          var other = tail.f4u_1;
          var this_1 = this_0.u2(toLong(other));
          var other_0 = tail.l4v() ? 0 : tail.e4u_1;
          tmp = this_1.v2(toLong(other_0)).e1(new Long(8192, 0)) <= 0;
        } else {
          tmp = false;
        }
        if (tmp) {
          ensureNotNull(source.v4t_1).n4v(tail, remainingByteCount.g1());
          source.x4t_1 = source.x4t_1.v2(remainingByteCount);
          this.x4t_1 = this.x4t_1.u2(remainingByteCount);
          return Unit_instance;
        } else {
          source.v4t_1 = ensureNotNull(source.v4t_1).m4v(remainingByteCount.g1());
        }
      }
      var segmentToMove = ensureNotNull(source.v4t_1);
      var movedByteCount = toLong(segmentToMove.k4u());
      source.v4t_1 = segmentToMove.o4v();
      if (source.v4t_1 == null) {
        source.w4t_1 = null;
      }
      // Inline function 'kotlinx.io.Buffer.pushSegment' call
      if (this.v4t_1 == null) {
        this.v4t_1 = segmentToMove;
        this.w4t_1 = segmentToMove;
      } else if (true) {
        this.w4t_1 = ensureNotNull(this.w4t_1).s4u(segmentToMove).t4u();
        if (ensureNotNull(this.w4t_1).j4u_1 == null) {
          this.v4t_1 = this.w4t_1;
        }
      } else {
        this.w4t_1 = ensureNotNull(this.w4t_1).s4u(segmentToMove);
      }
      source.x4t_1 = source.x4t_1.v2(movedByteCount);
      this.x4t_1 = this.x4t_1.u2(movedByteCount);
      remainingByteCount = remainingByteCount.v2(movedByteCount);
    }
  };
  protoOf(Buffer).p4v = function (source) {
    var totalBytesRead = new Long(0, 0);
    $l$loop: while (true) {
      var readCount = source.y4u(this, new Long(8192, 0));
      if (readCount.equals(new Long(-1, -1)))
        break $l$loop;
      totalBytesRead = totalBytesRead.u2(readCount);
    }
    return totalBytesRead;
  };
  protoOf(Buffer).q4v = function (byte) {
    this.d4v(1).r4v(byte);
    this.x4t_1 = this.x4t_1.u2(new Long(1, 0));
  };
  protoOf(Buffer).s4v = function (short) {
    this.d4v(2).t4v(short);
    this.x4t_1 = this.x4t_1.u2(new Long(2, 0));
  };
  protoOf(Buffer).u4v = function () {
    return Unit_instance;
  };
  protoOf(Buffer).toString = function () {
    if (this.j().equals(new Long(0, 0)))
      return 'Buffer(size=0)';
    var maxPrintableBytes = 64;
    // Inline function 'kotlinx.io.minOf' call
    var b = this.j();
    // Inline function 'kotlin.comparisons.minOf' call
    var a = toLong(maxPrintableBytes);
    var len = (a.e1(b) <= 0 ? a : b).g1();
    var builder = StringBuilder_init_$Create$(imul(len, 2) + (this.j().e1(toLong(maxPrintableBytes)) > 0 ? 1 : 0) | 0);
    var bytesWritten = 0;
    // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.forEachSegment' call
    var curr = this.v4t_1;
    while (!(curr == null)) {
      // Inline function 'kotlinx.io.Buffer.toString.<anonymous>' call
      var ctx = get_SegmentReadContextImpl();
      var segment = curr;
      var idx = 0;
      while (bytesWritten < len && idx < segment.k4u()) {
        var _unary__edvuaz = idx;
        idx = _unary__edvuaz + 1 | 0;
        var b_0 = ctx.v4v(segment, _unary__edvuaz);
        bytesWritten = bytesWritten + 1 | 0;
        var tmp = get_HEX_DIGIT_CHARS();
        // Inline function 'kotlinx.io.shr' call
        var tmp$ret$2 = b_0 >> 4;
        var tmp_0 = builder.j8(tmp[tmp$ret$2 & 15]);
        var tmp_1 = get_HEX_DIGIT_CHARS();
        // Inline function 'kotlinx.io.and' call
        var tmp$ret$3 = b_0 & 15;
        tmp_0.j8(tmp_1[tmp$ret$3]);
      }
      curr = curr.i4u_1;
    }
    if (this.j().e1(toLong(maxPrintableBytes)) > 0) {
      builder.j8(_Char___init__impl__6a9atx(8230));
    }
    return 'Buffer(size=' + this.j().toString() + ' hex=' + builder.toString() + ')';
  };
  protoOf(Buffer).l4u = function () {
    var oldHead = ensureNotNull(this.v4t_1);
    var nextHead = oldHead.i4u_1;
    this.v4t_1 = nextHead;
    if (nextHead == null) {
      this.w4t_1 = null;
    } else {
      nextHead.j4u_1 = null;
    }
    oldHead.i4u_1 = null;
    SegmentPool_instance.w4v(oldHead);
  };
  protoOf(Buffer).x4v = function () {
    var oldTail = ensureNotNull(this.w4t_1);
    var newTail = oldTail.j4u_1;
    this.w4t_1 = newTail;
    if (newTail == null) {
      this.v4t_1 = null;
    } else {
      newTail.i4u_1 = null;
    }
    oldTail.j4u_1 = null;
    SegmentPool_instance.w4v(oldTail);
  };
  function buffered(_this__u8e3s4) {
    return new RealSource(_this__u8e3s4);
  }
  function PeekSource(upstream) {
    this.y4v_1 = upstream;
    this.z4v_1 = this.y4v_1.y4t();
    this.a4w_1 = this.z4v_1.v4t_1;
    var tmp = this;
    var tmp0_safe_receiver = this.z4v_1.v4t_1;
    var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e4u_1;
    tmp.b4w_1 = tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs;
    this.c4w_1 = false;
    this.d4w_1 = new Long(0, 0);
  }
  protoOf(PeekSource).y4u = function (sink, byteCount) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!this.c4w_1) {
      // Inline function 'kotlinx.io.PeekSource.readAtMostTo.<anonymous>' call
      var message = 'Source is closed.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'kotlinx.io.checkByteCount' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(byteCount.e1(new Long(0, 0)) >= 0)) {
      // Inline function 'kotlinx.io.checkByteCount.<anonymous>' call
      var message_0 = 'byteCount (' + byteCount.toString() + ') < 0';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.a4w_1 == null || (this.a4w_1 === this.z4v_1.v4t_1 && this.b4w_1 === ensureNotNull(this.z4v_1.v4t_1).e4u_1))) {
      // Inline function 'kotlinx.io.PeekSource.readAtMostTo.<anonymous>' call
      var message_1 = 'Peek source is invalid because upstream source was used';
      throw IllegalStateException_init_$Create$(toString(message_1));
    }
    if (byteCount.equals(new Long(0, 0)))
      return new Long(0, 0);
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$3 = this.d4w_1.u2(toLong(1));
    if (!this.y4v_1.b4u(tmp$ret$3))
      return new Long(-1, -1);
    if (this.a4w_1 == null && !(this.z4v_1.v4t_1 == null)) {
      this.a4w_1 = this.z4v_1.v4t_1;
      this.b4w_1 = ensureNotNull(this.z4v_1.v4t_1).e4u_1;
    }
    // Inline function 'kotlin.comparisons.minOf' call
    var b = this.z4v_1.j().v2(this.d4w_1);
    var toCopy = byteCount.e1(b) <= 0 ? byteCount : b;
    this.z4v_1.q4u(sink, this.d4w_1, this.d4w_1.u2(toCopy));
    this.d4w_1 = this.d4w_1.u2(toCopy);
    return toCopy;
  };
  protoOf(PeekSource).u4v = function () {
    this.c4w_1 = true;
  };
  function RealSource(source) {
    this.e4w_1 = source;
    this.f4w_1 = false;
    this.g4w_1 = new Buffer();
  }
  protoOf(RealSource).y4t = function () {
    return this.g4w_1;
  };
  protoOf(RealSource).y4u = function (sink, byteCount) {
    // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!this.f4w_1) {
      // Inline function 'kotlinx.io.RealSource.checkNotClosed.<anonymous>' call
      var message = 'Source is closed.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(byteCount.e1(new Long(0, 0)) >= 0)) {
      // Inline function 'kotlinx.io.RealSource.readAtMostTo.<anonymous>' call
      var message_0 = 'byteCount: ' + byteCount.toString();
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    if (this.g4w_1.j().equals(new Long(0, 0))) {
      var read = this.e4w_1.y4u(this.g4w_1, new Long(8192, 0));
      if (read.equals(new Long(-1, -1)))
        return new Long(-1, -1);
    }
    // Inline function 'kotlin.comparisons.minOf' call
    var b = this.g4w_1.j();
    var toRead = byteCount.e1(b) <= 0 ? byteCount : b;
    return this.g4w_1.y4u(sink, toRead);
  };
  protoOf(RealSource).z4t = function () {
    // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!this.f4w_1) {
      // Inline function 'kotlinx.io.RealSource.checkNotClosed.<anonymous>' call
      var message = 'Source is closed.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return this.g4w_1.z4t() && this.e4w_1.y4u(this.g4w_1, new Long(8192, 0)).equals(new Long(-1, -1));
  };
  protoOf(RealSource).a4u = function (byteCount) {
    if (!this.b4u(byteCount))
      throw EOFException_init_$Create$_0("Source doesn't contain required number of bytes (" + byteCount.toString() + ').');
  };
  protoOf(RealSource).b4u = function (byteCount) {
    // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!this.f4w_1) {
      // Inline function 'kotlinx.io.RealSource.checkNotClosed.<anonymous>' call
      var message = 'Source is closed.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(byteCount.e1(new Long(0, 0)) >= 0)) {
      // Inline function 'kotlinx.io.RealSource.request.<anonymous>' call
      var message_0 = 'byteCount: ' + byteCount.toString();
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    while (this.g4w_1.j().e1(byteCount) < 0) {
      if (this.e4w_1.y4u(this.g4w_1, new Long(8192, 0)).equals(new Long(-1, -1)))
        return false;
    }
    return true;
  };
  protoOf(RealSource).w4u = function (sink, startIndex, endIndex) {
    // Inline function 'kotlinx.io.checkBounds' call
    var size = sink.length;
    checkBounds(toLong(size), toLong(startIndex), toLong(endIndex));
    if (this.g4w_1.j().equals(new Long(0, 0))) {
      var read = this.e4w_1.y4u(this.g4w_1, new Long(8192, 0));
      if (read.equals(new Long(-1, -1)))
        return -1;
    }
    // Inline function 'kotlinx.io.minOf' call
    var a = endIndex - startIndex | 0;
    var b = this.g4w_1.j();
    // Inline function 'kotlin.comparisons.minOf' call
    var a_0 = toLong(a);
    var toRead = (a_0.e1(b) <= 0 ? a_0 : b).g1();
    return this.g4w_1.w4u(sink, startIndex, startIndex + toRead | 0);
  };
  protoOf(RealSource).a4v = function (sink, byteCount) {
    try {
      this.a4u(byteCount);
    } catch ($p) {
      if ($p instanceof EOFException) {
        var e = $p;
        sink.z4u(this.g4w_1, this.g4w_1.j());
        throw e;
      } else {
        throw $p;
      }
    }
    this.g4w_1.a4v(sink, byteCount);
  };
  protoOf(RealSource).b4v = function (sink) {
    var totalBytesWritten = new Long(0, 0);
    while (!this.e4w_1.y4u(this.g4w_1, new Long(8192, 0)).equals(new Long(-1, -1))) {
      var emitByteCount = this.g4w_1.u4u();
      if (emitByteCount.e1(new Long(0, 0)) > 0) {
        totalBytesWritten = totalBytesWritten.u2(emitByteCount);
        sink.z4u(this.g4w_1, emitByteCount);
      }
    }
    if (this.g4w_1.j().e1(new Long(0, 0)) > 0) {
      totalBytesWritten = totalBytesWritten.u2(this.g4w_1.j());
      sink.z4u(this.g4w_1, this.g4w_1.j());
    }
    return totalBytesWritten;
  };
  protoOf(RealSource).n4u = function () {
    this.a4u(new Long(2, 0));
    return this.g4w_1.n4u();
  };
  protoOf(RealSource).c4v = function () {
    // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!this.f4w_1) {
      // Inline function 'kotlinx.io.RealSource.checkNotClosed.<anonymous>' call
      var message = 'Source is closed.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return buffered(new PeekSource(this));
  };
  protoOf(RealSource).u4v = function () {
    if (this.f4w_1)
      return Unit_instance;
    this.f4w_1 = true;
    this.e4w_1.u4v();
    this.g4w_1.g2();
  };
  protoOf(RealSource).toString = function () {
    return 'buffered(' + toString(this.e4w_1) + ')';
  };
  function Segment_init_$Init$($this) {
    Segment.call($this);
    $this.d4u_1 = new Int8Array(8192);
    $this.h4u_1 = true;
    $this.g4u_1 = null;
    return $this;
  }
  function Segment_init_$Create$() {
    return Segment_init_$Init$(objectCreate(protoOf(Segment)));
  }
  function Segment_init_$Init$_0(data, pos, limit, shareToken, owner, $this) {
    Segment.call($this);
    $this.d4u_1 = data;
    $this.e4u_1 = pos;
    $this.f4u_1 = limit;
    $this.g4u_1 = shareToken;
    $this.h4u_1 = owner;
    return $this;
  }
  function Segment_init_$Create$_0(data, pos, limit, shareToken, owner) {
    return Segment_init_$Init$_0(data, pos, limit, shareToken, owner, objectCreate(protoOf(Segment)));
  }
  function Companion() {
    this.h4w_1 = 8192;
    this.i4w_1 = 1024;
  }
  protoOf(Companion).j4w = function () {
    return Segment_init_$Create$();
  };
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  protoOf(Segment).l4v = function () {
    var tmp1_safe_receiver = this.g4u_1;
    var tmp0_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.k4w();
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  };
  protoOf(Segment).r4u = function () {
    var tmp0_elvis_lhs = this.g4u_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = SegmentPool_instance.l4w();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.io.Segment.sharedCopy.<anonymous>' call
      this.g4u_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var t = tmp;
    var tmp_0 = this.e4u_1;
    var tmp_1 = this.f4u_1;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.io.Segment.sharedCopy.<anonymous>' call
    t.m4w();
    return Segment_init_$Create$_0(this.d4u_1, tmp_0, tmp_1, t, false);
  };
  protoOf(Segment).o4v = function () {
    var result = this.i4u_1;
    if (!(this.j4u_1 == null)) {
      ensureNotNull(this.j4u_1).i4u_1 = this.i4u_1;
    }
    if (!(this.i4u_1 == null)) {
      ensureNotNull(this.i4u_1).j4u_1 = this.j4u_1;
    }
    this.i4u_1 = null;
    this.j4u_1 = null;
    return result;
  };
  protoOf(Segment).s4u = function (segment) {
    segment.j4u_1 = this;
    segment.i4u_1 = this.i4u_1;
    if (!(this.i4u_1 == null)) {
      ensureNotNull(this.i4u_1).j4u_1 = segment;
    }
    this.i4u_1 = segment;
    return segment;
  };
  protoOf(Segment).m4v = function (byteCount) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(byteCount > 0 && byteCount <= (this.f4u_1 - this.e4u_1 | 0))) {
      // Inline function 'kotlinx.io.Segment.split.<anonymous>' call
      var message = 'byteCount out of range';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var prefix;
    if (byteCount >= 1024) {
      prefix = this.r4u();
    } else {
      prefix = SegmentPool_instance.g4v();
      // Inline function 'kotlin.collections.copyInto' call
      var this_0 = this.d4u_1;
      var destination = prefix.d4u_1;
      var startIndex = this.e4u_1;
      var endIndex = this.e4u_1 + byteCount | 0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = this_0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp, destination, 0, startIndex, endIndex);
    }
    prefix.f4u_1 = prefix.e4u_1 + byteCount | 0;
    this.e4u_1 = this.e4u_1 + byteCount | 0;
    if (!(this.j4u_1 == null)) {
      ensureNotNull(this.j4u_1).s4u(prefix);
    } else {
      prefix.i4u_1 = this;
      this.j4u_1 = prefix;
    }
    return prefix;
  };
  protoOf(Segment).t4u = function () {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!(this.j4u_1 == null)) {
      // Inline function 'kotlinx.io.Segment.compact.<anonymous>' call
      var message = 'cannot compact';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if (!ensureNotNull(this.j4u_1).h4u_1)
      return this;
    var byteCount = this.f4u_1 - this.e4u_1 | 0;
    var availableByteCount = (8192 - ensureNotNull(this.j4u_1).f4u_1 | 0) + (ensureNotNull(this.j4u_1).l4v() ? 0 : ensureNotNull(this.j4u_1).e4u_1) | 0;
    if (byteCount > availableByteCount)
      return this;
    var predecessor = this.j4u_1;
    this.n4v(ensureNotNull(predecessor), byteCount);
    var successor = this.o4v();
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(successor == null)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_0 = 'Check failed.';
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
    SegmentPool_instance.w4v(this);
    return predecessor;
  };
  protoOf(Segment).r4v = function (byte) {
    var _unary__edvuaz = this.f4u_1;
    this.f4u_1 = _unary__edvuaz + 1 | 0;
    this.d4u_1[_unary__edvuaz] = byte;
  };
  protoOf(Segment).t4v = function (short) {
    var data = this.d4u_1;
    var limit = this.f4u_1;
    var _unary__edvuaz = limit;
    limit = _unary__edvuaz + 1 | 0;
    data[_unary__edvuaz] = toByte((short >>> 8 | 0) & 255);
    var _unary__edvuaz_0 = limit;
    limit = _unary__edvuaz_0 + 1 | 0;
    data[_unary__edvuaz_0] = toByte(short & 255);
    this.f4u_1 = limit;
  };
  protoOf(Segment).m4u = function () {
    var _unary__edvuaz = this.e4u_1;
    this.e4u_1 = _unary__edvuaz + 1 | 0;
    return this.d4u_1[_unary__edvuaz];
  };
  protoOf(Segment).o4u = function () {
    var data = this.d4u_1;
    var pos = this.e4u_1;
    // Inline function 'kotlinx.io.and' call
    var _unary__edvuaz = pos;
    pos = _unary__edvuaz + 1 | 0;
    var tmp = (data[_unary__edvuaz] & 255) << 8;
    // Inline function 'kotlinx.io.and' call
    var _unary__edvuaz_0 = pos;
    pos = _unary__edvuaz_0 + 1 | 0;
    var tmp$ret$1 = data[_unary__edvuaz_0] & 255;
    var s = toShort(tmp | tmp$ret$1);
    this.e4u_1 = pos;
    return s;
  };
  protoOf(Segment).n4v = function (sink, byteCount) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!sink.h4u_1) {
      // Inline function 'kotlinx.io.Segment.writeTo.<anonymous>' call
      var message = 'only owner can write';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if ((sink.f4u_1 + byteCount | 0) > 8192) {
      if (sink.l4v())
        throw IllegalArgumentException_init_$Create$_0();
      if (((sink.f4u_1 + byteCount | 0) - sink.e4u_1 | 0) > 8192)
        throw IllegalArgumentException_init_$Create$_0();
      // Inline function 'kotlin.collections.copyInto' call
      var this_0 = sink.d4u_1;
      var destination = sink.d4u_1;
      var startIndex = sink.e4u_1;
      var endIndex = sink.f4u_1;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = this_0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp, destination, 0, startIndex, endIndex);
      sink.f4u_1 = sink.f4u_1 - sink.e4u_1 | 0;
      sink.e4u_1 = 0;
    }
    // Inline function 'kotlin.collections.copyInto' call
    var this_1 = this.d4u_1;
    var destination_0 = sink.d4u_1;
    var destinationOffset = sink.f4u_1;
    var startIndex_0 = this.e4u_1;
    var endIndex_0 = this.e4u_1 + byteCount | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = this_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp_0, destination_0, destinationOffset, startIndex_0, endIndex_0);
    sink.f4u_1 = sink.f4u_1 + byteCount | 0;
    this.e4u_1 = this.e4u_1 + byteCount | 0;
  };
  protoOf(Segment).x4u = function (dst, dstStartOffset, dstEndOffset) {
    var len = dstEndOffset - dstStartOffset | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var this_0 = this.d4u_1;
    var startIndex = this.e4u_1;
    var endIndex = this.e4u_1 + len | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = this_0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstStartOffset, startIndex, endIndex);
    this.e4u_1 = this.e4u_1 + len | 0;
  };
  protoOf(Segment).j4v = function (src, srcStartOffset, srcEndOffset) {
    // Inline function 'kotlin.collections.copyInto' call
    var destination = this.d4u_1;
    var destinationOffset = this.f4u_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, destination, destinationOffset, srcStartOffset, srcEndOffset);
    this.f4u_1 = this.f4u_1 + (srcEndOffset - srcStartOffset | 0) | 0;
  };
  protoOf(Segment).k4u = function () {
    return this.f4u_1 - this.e4u_1 | 0;
  };
  protoOf(Segment).i4v = function () {
    return this.d4u_1.length - this.f4u_1 | 0;
  };
  protoOf(Segment).n4w = function (readOnly) {
    return this.d4u_1;
  };
  protoOf(Segment).o4w = function (index) {
    return this.d4u_1[this.e4u_1 + index | 0];
  };
  protoOf(Segment).p4w = function (index, value) {
    this.d4u_1[this.f4u_1 + index | 0] = value;
  };
  protoOf(Segment).q4w = function (index, b0, b1) {
    var d = this.d4u_1;
    var l = this.f4u_1;
    d[l + index | 0] = b0;
    d[(l + index | 0) + 1 | 0] = b1;
  };
  protoOf(Segment).r4w = function (index, b0, b1, b2) {
    var d = this.d4u_1;
    var l = this.f4u_1;
    d[l + index | 0] = b0;
    d[(l + index | 0) + 1 | 0] = b1;
    d[(l + index | 0) + 2 | 0] = b2;
  };
  protoOf(Segment).s4w = function (index, b0, b1, b2, b3) {
    var d = this.d4u_1;
    var l = this.f4u_1;
    d[l + index | 0] = b0;
    d[(l + index | 0) + 1 | 0] = b1;
    d[(l + index | 0) + 2 | 0] = b2;
    d[(l + index | 0) + 3 | 0] = b3;
  };
  function Segment() {
    this.e4u_1 = 0;
    this.f4u_1 = 0;
    this.g4u_1 = null;
    this.h4u_1 = false;
    this.i4u_1 = null;
    this.j4u_1 = null;
  }
  function SegmentCopyTracker() {
  }
  function isEmpty(_this__u8e3s4) {
    return _this__u8e3s4.k4u() === 0;
  }
  function AlwaysSharedCopyTracker() {
    AlwaysSharedCopyTracker_instance = this;
    SegmentCopyTracker.call(this);
  }
  protoOf(AlwaysSharedCopyTracker).k4w = function () {
    return true;
  };
  protoOf(AlwaysSharedCopyTracker).m4w = function () {
    return Unit_instance;
  };
  var AlwaysSharedCopyTracker_instance;
  function AlwaysSharedCopyTracker_getInstance() {
    if (AlwaysSharedCopyTracker_instance == null)
      new AlwaysSharedCopyTracker();
    return AlwaysSharedCopyTracker_instance;
  }
  function Sink() {
  }
  function Source() {
  }
  function readByteArray(_this__u8e3s4) {
    return readByteArrayImpl(_this__u8e3s4, -1);
  }
  function readByteArrayImpl(_this__u8e3s4, size) {
    var arraySize = size;
    if (size === -1) {
      var fetchSize = new Long(2147483647, 0);
      while (_this__u8e3s4.y4t().j().e1(new Long(2147483647, 0)) < 0 && _this__u8e3s4.b4u(fetchSize)) {
        // Inline function 'kotlin.Long.times' call
        fetchSize = fetchSize.w2(toLong(2));
      }
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(_this__u8e3s4.y4t().j().e1(new Long(2147483647, 0)) < 0)) {
        // Inline function 'kotlinx.io.readByteArrayImpl.<anonymous>' call
        var message = "Can't create an array of size " + _this__u8e3s4.y4t().j().toString();
        throw IllegalStateException_init_$Create$(toString(message));
      }
      arraySize = _this__u8e3s4.y4t().j().g1();
    } else {
      _this__u8e3s4.a4u(toLong(size));
    }
    var array = new Int8Array(arraySize);
    readTo(_this__u8e3s4.y4t(), array);
    return array;
  }
  function readTo(_this__u8e3s4, sink, startIndex, endIndex) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    endIndex = endIndex === VOID ? sink.length : endIndex;
    // Inline function 'kotlinx.io.checkBounds' call
    var size = sink.length;
    checkBounds(toLong(size), toLong(startIndex), toLong(endIndex));
    var offset = startIndex;
    while (offset < endIndex) {
      var bytesRead = _this__u8e3s4.w4u(sink, offset, endIndex);
      if (bytesRead === -1) {
        throw EOFException_init_$Create$_0('Source exhausted before reading ' + (endIndex - startIndex | 0) + ' bytes. ' + ('Only ' + bytesRead + ' bytes were read.'));
      }
      offset = offset + bytesRead | 0;
    }
  }
  function readByteArray_0(_this__u8e3s4, byteCount) {
    // Inline function 'kotlinx.io.checkByteCount' call
    var byteCount_0 = toLong(byteCount);
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(byteCount_0.e1(new Long(0, 0)) >= 0)) {
      // Inline function 'kotlinx.io.checkByteCount.<anonymous>' call
      var message = 'byteCount (' + byteCount_0.toString() + ') < 0';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return readByteArrayImpl(_this__u8e3s4, byteCount);
  }
  function readString(_this__u8e3s4) {
    _this__u8e3s4.b4u(new Long(-1, 2147483647));
    return commonReadUtf8(_this__u8e3s4.y4t(), _this__u8e3s4.y4t().j());
  }
  function readString_0(_this__u8e3s4, byteCount) {
    _this__u8e3s4.a4u(byteCount);
    return commonReadUtf8(_this__u8e3s4.y4t(), byteCount);
  }
  function commonReadUtf8(_this__u8e3s4, byteCount) {
    if (byteCount.equals(new Long(0, 0)))
      return '';
    // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.forEachSegment' call
    var curr = _this__u8e3s4.v4t_1;
    while (!(curr == null)) {
      // Inline function 'kotlinx.io.commonReadUtf8.<anonymous>' call
      get_SegmentReadContextImpl();
      if (toLong(curr.k4u()).e1(byteCount) >= 0) {
        var result = '';
        // Inline function 'kotlinx.io.unsafe.withData' call
        // Inline function 'kotlinx.io.commonReadUtf8.<anonymous>.<anonymous>' call
        var data = curr.n4w(true);
        var pos = curr.e4u_1;
        // Inline function 'kotlin.math.min' call
        var a = curr.f4u_1;
        var b = pos + byteCount.g1() | 0;
        var tmp$ret$0 = Math.min(a, b);
        result = commonToUtf8String(data, pos, tmp$ret$0);
        _this__u8e3s4.v4u(byteCount);
        return result;
      }
      return commonToUtf8String(readByteArray_0(_this__u8e3s4, byteCount.g1()));
    }
    // Inline function 'kotlin.error' call
    var message = 'Unreacheable';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  function writeString(_this__u8e3s4, string, startIndex, endIndex) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    endIndex = endIndex === VOID ? string.length : endIndex;
    // Inline function 'kotlinx.io.checkBounds' call
    var size = string.length;
    checkBounds(toLong(size), toLong(startIndex), toLong(endIndex));
    // Inline function 'kotlinx.io.writeToInternalBuffer' call
    // Inline function 'kotlinx.io.writeString.<anonymous>' call
    // Inline function 'kotlinx.io.commonWriteUtf8' call
    var this_0 = _this__u8e3s4.y4t();
    var i = startIndex;
    while (i < endIndex) {
      // Inline function 'kotlin.code' call
      var p0 = i;
      var this_1 = charSequenceGet(string, p0);
      var c = Char__toInt_impl_vasixd(this_1);
      if (c < 128) {
        $l$block_0: {
          // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail' call
          var tail = this_0.d4v(1);
          // Inline function 'kotlinx.io.commonWriteUtf8.<anonymous>' call
          var ctx = get_SegmentWriteContextImpl();
          var segmentOffset = -i | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = i + tail.i4v() | 0;
          var runLimit = Math.min(endIndex, b);
          var _unary__edvuaz = i;
          i = _unary__edvuaz + 1 | 0;
          ctx.w4w(tail, segmentOffset + _unary__edvuaz | 0, toByte(c));
          $l$loop: while (i < runLimit) {
            // Inline function 'kotlin.code' call
            var p0_0 = i;
            var this_2 = charSequenceGet(string, p0_0);
            c = Char__toInt_impl_vasixd(this_2);
            if (c >= 128)
              break $l$loop;
            var _unary__edvuaz_0 = i;
            i = _unary__edvuaz_0 + 1 | 0;
            ctx.w4w(tail, segmentOffset + _unary__edvuaz_0 | 0, toByte(c));
          }
          var bytesWritten = i + segmentOffset | 0;
          if (bytesWritten === 1) {
            tail.f4u_1 = tail.f4u_1 + bytesWritten | 0;
            var tmp = this_0;
            // Inline function 'kotlin.Long.plus' call
            tmp.x4t_1 = this_0.x4t_1.u2(toLong(bytesWritten));
            break $l$block_0;
          }
          // Inline function 'kotlin.check' call
          // Inline function 'kotlin.contracts.contract' call
          if (!(0 <= bytesWritten ? bytesWritten <= tail.i4v() : false)) {
            // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail.<anonymous>' call
            var message = 'Invalid number of bytes written: ' + bytesWritten + '. Should be in 0..' + tail.i4v();
            throw IllegalStateException_init_$Create$(toString(message));
          }
          if (!(bytesWritten === 0)) {
            tail.f4u_1 = tail.f4u_1 + bytesWritten | 0;
            var tmp_0 = this_0;
            // Inline function 'kotlin.Long.plus' call
            tmp_0.x4t_1 = this_0.x4t_1.u2(toLong(bytesWritten));
            break $l$block_0;
          }
          if (isEmpty(tail)) {
            this_0.x4v();
          }
        }
      } else if (c < 2048) {
        $l$block_2: {
          // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail' call
          var tail_0 = this_0.d4v(2);
          // Inline function 'kotlinx.io.commonWriteUtf8.<anonymous>' call
          get_SegmentWriteContextImpl().v4w(tail_0, 0, toByte(c >> 6 | 192), toByte(c & 63 | 128));
          var bytesWritten_0 = 2;
          if (bytesWritten_0 === 2) {
            tail_0.f4u_1 = tail_0.f4u_1 + bytesWritten_0 | 0;
            var tmp_1 = this_0;
            // Inline function 'kotlin.Long.plus' call
            tmp_1.x4t_1 = this_0.x4t_1.u2(toLong(bytesWritten_0));
            break $l$block_2;
          }
          // Inline function 'kotlin.check' call
          // Inline function 'kotlin.contracts.contract' call
          if (!(0 <= bytesWritten_0 ? bytesWritten_0 <= tail_0.i4v() : false)) {
            // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail.<anonymous>' call
            var message_0 = 'Invalid number of bytes written: ' + bytesWritten_0 + '. Should be in 0..' + tail_0.i4v();
            throw IllegalStateException_init_$Create$(toString(message_0));
          }
          if (!(bytesWritten_0 === 0)) {
            tail_0.f4u_1 = tail_0.f4u_1 + bytesWritten_0 | 0;
            var tmp_2 = this_0;
            // Inline function 'kotlin.Long.plus' call
            tmp_2.x4t_1 = this_0.x4t_1.u2(toLong(bytesWritten_0));
            break $l$block_2;
          }
          if (isEmpty(tail_0)) {
            this_0.x4v();
          }
        }
        i = i + 1 | 0;
      } else if (c < 55296 || c > 57343) {
        $l$block_4: {
          // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail' call
          var tail_1 = this_0.d4v(3);
          // Inline function 'kotlinx.io.commonWriteUtf8.<anonymous>' call
          get_SegmentWriteContextImpl().u4w(tail_1, 0, toByte(c >> 12 | 224), toByte(c >> 6 & 63 | 128), toByte(c & 63 | 128));
          var bytesWritten_1 = 3;
          if (bytesWritten_1 === 3) {
            tail_1.f4u_1 = tail_1.f4u_1 + bytesWritten_1 | 0;
            var tmp_3 = this_0;
            // Inline function 'kotlin.Long.plus' call
            tmp_3.x4t_1 = this_0.x4t_1.u2(toLong(bytesWritten_1));
            break $l$block_4;
          }
          // Inline function 'kotlin.check' call
          // Inline function 'kotlin.contracts.contract' call
          if (!(0 <= bytesWritten_1 ? bytesWritten_1 <= tail_1.i4v() : false)) {
            // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail.<anonymous>' call
            var message_1 = 'Invalid number of bytes written: ' + bytesWritten_1 + '. Should be in 0..' + tail_1.i4v();
            throw IllegalStateException_init_$Create$(toString(message_1));
          }
          if (!(bytesWritten_1 === 0)) {
            tail_1.f4u_1 = tail_1.f4u_1 + bytesWritten_1 | 0;
            var tmp_4 = this_0;
            // Inline function 'kotlin.Long.plus' call
            tmp_4.x4t_1 = this_0.x4t_1.u2(toLong(bytesWritten_1));
            break $l$block_4;
          }
          if (isEmpty(tail_1)) {
            this_0.x4v();
          }
        }
        i = i + 1 | 0;
      } else {
        var tmp_5;
        if ((i + 1 | 0) < endIndex) {
          // Inline function 'kotlin.code' call
          var p0_1 = i + 1 | 0;
          var this_3 = charSequenceGet(string, p0_1);
          tmp_5 = Char__toInt_impl_vasixd(this_3);
        } else {
          tmp_5 = 0;
        }
        var low = tmp_5;
        if (c > 56319 || !(56320 <= low ? low <= 57343 : false)) {
          this_0.q4v(63);
          i = i + 1 | 0;
        } else {
          var codePoint = 65536 + ((c & 1023) << 10 | low & 1023) | 0;
          $l$block_6: {
            // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail' call
            var tail_2 = this_0.d4v(4);
            // Inline function 'kotlinx.io.commonWriteUtf8.<anonymous>' call
            get_SegmentWriteContextImpl().t4w(tail_2, 0, toByte(codePoint >> 18 | 240), toByte(codePoint >> 12 & 63 | 128), toByte(codePoint >> 6 & 63 | 128), toByte(codePoint & 63 | 128));
            var bytesWritten_2 = 4;
            if (bytesWritten_2 === 4) {
              tail_2.f4u_1 = tail_2.f4u_1 + bytesWritten_2 | 0;
              var tmp_6 = this_0;
              // Inline function 'kotlin.Long.plus' call
              tmp_6.x4t_1 = this_0.x4t_1.u2(toLong(bytesWritten_2));
              break $l$block_6;
            }
            // Inline function 'kotlin.check' call
            // Inline function 'kotlin.contracts.contract' call
            if (!(0 <= bytesWritten_2 ? bytesWritten_2 <= tail_2.i4v() : false)) {
              // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail.<anonymous>' call
              var message_2 = 'Invalid number of bytes written: ' + bytesWritten_2 + '. Should be in 0..' + tail_2.i4v();
              throw IllegalStateException_init_$Create$(toString(message_2));
            }
            if (!(bytesWritten_2 === 0)) {
              tail_2.f4u_1 = tail_2.f4u_1 + bytesWritten_2 | 0;
              var tmp_7 = this_0;
              // Inline function 'kotlin.Long.plus' call
              tmp_7.x4t_1 = this_0.x4t_1.u2(toLong(bytesWritten_2));
              break $l$block_6;
            }
            if (isEmpty(tail_2)) {
              this_0.x4v();
            }
          }
          i = i + 2 | 0;
        }
      }
    }
    _this__u8e3s4.p4u();
  }
  function commonToUtf8String(_this__u8e3s4, beginIndex, endIndex) {
    beginIndex = beginIndex === VOID ? 0 : beginIndex;
    endIndex = endIndex === VOID ? _this__u8e3s4.length : endIndex;
    if (beginIndex < 0 || endIndex > _this__u8e3s4.length || beginIndex > endIndex) {
      throw IndexOutOfBoundsException_init_$Create$('size=' + _this__u8e3s4.length + ' beginIndex=' + beginIndex + ' endIndex=' + endIndex);
    }
    var chars = charArray(endIndex - beginIndex | 0);
    var length = 0;
    // Inline function 'kotlinx.io.internal.processUtf16Chars' call
    var index = beginIndex;
    while (index < endIndex) {
      var b0 = _this__u8e3s4[index];
      if (b0 >= 0) {
        // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
        var _unary__edvuaz = length;
        length = _unary__edvuaz + 1 | 0;
        chars[_unary__edvuaz] = numberToChar(b0);
        index = index + 1 | 0;
        while (index < endIndex && _this__u8e3s4[index] >= 0) {
          // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
          var _unary__edvuaz_0 = index;
          index = _unary__edvuaz_0 + 1 | 0;
          var _unary__edvuaz_1 = length;
          length = _unary__edvuaz_1 + 1 | 0;
          chars[_unary__edvuaz_1] = numberToChar(_this__u8e3s4[_unary__edvuaz_0]);
        }
      } else {
        // Inline function 'kotlinx.io.shr' call
        if (b0 >> 5 === -2) {
          var tmp = index;
          var tmp$ret$1;
          $l$block_0: {
            // Inline function 'kotlinx.io.internal.process2Utf8Bytes' call
            var beginIndex_0 = index;
            if (endIndex <= (beginIndex_0 + 1 | 0)) {
              // Inline function 'kotlinx.io.internal.processUtf16Chars.<anonymous>' call
              // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
              var _unary__edvuaz_2 = length;
              length = _unary__edvuaz_2 + 1 | 0;
              chars[_unary__edvuaz_2] = numberToChar(65533);
              tmp$ret$1 = 1;
              break $l$block_0;
            }
            var b0_0 = _this__u8e3s4[beginIndex_0];
            var b1 = _this__u8e3s4[beginIndex_0 + 1 | 0];
            // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
            // Inline function 'kotlinx.io.and' call
            if (!((b1 & 192) === 128)) {
              // Inline function 'kotlinx.io.internal.processUtf16Chars.<anonymous>' call
              // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
              var _unary__edvuaz_3 = length;
              length = _unary__edvuaz_3 + 1 | 0;
              chars[_unary__edvuaz_3] = numberToChar(65533);
              tmp$ret$1 = 1;
              break $l$block_0;
            }
            var codePoint = 3968 ^ b1 ^ b0_0 << 6;
            if (codePoint < 128) {
              // Inline function 'kotlinx.io.internal.processUtf16Chars.<anonymous>' call
              // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
              var _unary__edvuaz_4 = length;
              length = _unary__edvuaz_4 + 1 | 0;
              chars[_unary__edvuaz_4] = numberToChar(65533);
            } else {
              // Inline function 'kotlinx.io.internal.processUtf16Chars.<anonymous>' call
              // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
              var _unary__edvuaz_5 = length;
              length = _unary__edvuaz_5 + 1 | 0;
              chars[_unary__edvuaz_5] = numberToChar(codePoint);
            }
            tmp$ret$1 = 2;
          }
          index = tmp + tmp$ret$1 | 0;
        } else {
          // Inline function 'kotlinx.io.shr' call
          if (b0 >> 4 === -2) {
            var tmp_0 = index;
            var tmp$ret$7;
            $l$block_4: {
              // Inline function 'kotlinx.io.internal.process3Utf8Bytes' call
              var beginIndex_1 = index;
              if (endIndex <= (beginIndex_1 + 2 | 0)) {
                // Inline function 'kotlinx.io.internal.processUtf16Chars.<anonymous>' call
                // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                var _unary__edvuaz_6 = length;
                length = _unary__edvuaz_6 + 1 | 0;
                chars[_unary__edvuaz_6] = numberToChar(65533);
                var tmp_1;
                if (endIndex <= (beginIndex_1 + 1 | 0)) {
                  tmp_1 = true;
                } else {
                  // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
                  // Inline function 'kotlinx.io.and' call
                  tmp_1 = !((_this__u8e3s4[beginIndex_1 + 1 | 0] & 192) === 128);
                }
                if (tmp_1) {
                  tmp$ret$7 = 1;
                  break $l$block_4;
                } else {
                  tmp$ret$7 = 2;
                  break $l$block_4;
                }
              }
              var b0_1 = _this__u8e3s4[beginIndex_1];
              var b1_0 = _this__u8e3s4[beginIndex_1 + 1 | 0];
              // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
              // Inline function 'kotlinx.io.and' call
              if (!((b1_0 & 192) === 128)) {
                // Inline function 'kotlinx.io.internal.processUtf16Chars.<anonymous>' call
                // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                var _unary__edvuaz_7 = length;
                length = _unary__edvuaz_7 + 1 | 0;
                chars[_unary__edvuaz_7] = numberToChar(65533);
                tmp$ret$7 = 1;
                break $l$block_4;
              }
              var b2 = _this__u8e3s4[beginIndex_1 + 2 | 0];
              // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
              // Inline function 'kotlinx.io.and' call
              if (!((b2 & 192) === 128)) {
                // Inline function 'kotlinx.io.internal.processUtf16Chars.<anonymous>' call
                // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                var _unary__edvuaz_8 = length;
                length = _unary__edvuaz_8 + 1 | 0;
                chars[_unary__edvuaz_8] = numberToChar(65533);
                tmp$ret$7 = 2;
                break $l$block_4;
              }
              var codePoint_0 = -123008 ^ b2 ^ b1_0 << 6 ^ b0_1 << 12;
              if (codePoint_0 < 2048) {
                // Inline function 'kotlinx.io.internal.processUtf16Chars.<anonymous>' call
                // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                var _unary__edvuaz_9 = length;
                length = _unary__edvuaz_9 + 1 | 0;
                chars[_unary__edvuaz_9] = numberToChar(65533);
              } else if (55296 <= codePoint_0 ? codePoint_0 <= 57343 : false) {
                // Inline function 'kotlinx.io.internal.processUtf16Chars.<anonymous>' call
                // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                var _unary__edvuaz_10 = length;
                length = _unary__edvuaz_10 + 1 | 0;
                chars[_unary__edvuaz_10] = numberToChar(65533);
              } else {
                // Inline function 'kotlinx.io.internal.processUtf16Chars.<anonymous>' call
                // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                var _unary__edvuaz_11 = length;
                length = _unary__edvuaz_11 + 1 | 0;
                chars[_unary__edvuaz_11] = numberToChar(codePoint_0);
              }
              tmp$ret$7 = 3;
            }
            index = tmp_0 + tmp$ret$7 | 0;
          } else {
            // Inline function 'kotlinx.io.shr' call
            if (b0 >> 3 === -2) {
              var tmp_2 = index;
              var tmp$ret$15;
              $l$block_10: {
                // Inline function 'kotlinx.io.internal.process4Utf8Bytes' call
                var beginIndex_2 = index;
                if (endIndex <= (beginIndex_2 + 3 | 0)) {
                  // Inline function 'kotlinx.io.internal.processUtf16Chars.<anonymous>' call
                  if (!(65533 === 65533)) {
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_12 = length;
                    length = _unary__edvuaz_12 + 1 | 0;
                    chars[_unary__edvuaz_12] = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_13 = length;
                    length = _unary__edvuaz_13 + 1 | 0;
                    chars[_unary__edvuaz_13] = numberToChar((65533 & 1023) + 56320 | 0);
                  } else {
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_14 = length;
                    length = _unary__edvuaz_14 + 1 | 0;
                    chars[_unary__edvuaz_14] = _Char___init__impl__6a9atx(65533);
                  }
                  var tmp_3;
                  if (endIndex <= (beginIndex_2 + 1 | 0)) {
                    tmp_3 = true;
                  } else {
                    // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
                    // Inline function 'kotlinx.io.and' call
                    tmp_3 = !((_this__u8e3s4[beginIndex_2 + 1 | 0] & 192) === 128);
                  }
                  if (tmp_3) {
                    tmp$ret$15 = 1;
                    break $l$block_10;
                  } else {
                    var tmp_4;
                    if (endIndex <= (beginIndex_2 + 2 | 0)) {
                      tmp_4 = true;
                    } else {
                      // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
                      // Inline function 'kotlinx.io.and' call
                      tmp_4 = !((_this__u8e3s4[beginIndex_2 + 2 | 0] & 192) === 128);
                    }
                    if (tmp_4) {
                      tmp$ret$15 = 2;
                      break $l$block_10;
                    } else {
                      tmp$ret$15 = 3;
                      break $l$block_10;
                    }
                  }
                }
                var b0_2 = _this__u8e3s4[beginIndex_2];
                var b1_1 = _this__u8e3s4[beginIndex_2 + 1 | 0];
                // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
                // Inline function 'kotlinx.io.and' call
                if (!((b1_1 & 192) === 128)) {
                  // Inline function 'kotlinx.io.internal.processUtf16Chars.<anonymous>' call
                  if (!(65533 === 65533)) {
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_15 = length;
                    length = _unary__edvuaz_15 + 1 | 0;
                    chars[_unary__edvuaz_15] = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_16 = length;
                    length = _unary__edvuaz_16 + 1 | 0;
                    chars[_unary__edvuaz_16] = numberToChar((65533 & 1023) + 56320 | 0);
                  } else {
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_17 = length;
                    length = _unary__edvuaz_17 + 1 | 0;
                    chars[_unary__edvuaz_17] = _Char___init__impl__6a9atx(65533);
                  }
                  tmp$ret$15 = 1;
                  break $l$block_10;
                }
                var b2_0 = _this__u8e3s4[beginIndex_2 + 2 | 0];
                // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
                // Inline function 'kotlinx.io.and' call
                if (!((b2_0 & 192) === 128)) {
                  // Inline function 'kotlinx.io.internal.processUtf16Chars.<anonymous>' call
                  if (!(65533 === 65533)) {
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_18 = length;
                    length = _unary__edvuaz_18 + 1 | 0;
                    chars[_unary__edvuaz_18] = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_19 = length;
                    length = _unary__edvuaz_19 + 1 | 0;
                    chars[_unary__edvuaz_19] = numberToChar((65533 & 1023) + 56320 | 0);
                  } else {
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_20 = length;
                    length = _unary__edvuaz_20 + 1 | 0;
                    chars[_unary__edvuaz_20] = _Char___init__impl__6a9atx(65533);
                  }
                  tmp$ret$15 = 2;
                  break $l$block_10;
                }
                var b3 = _this__u8e3s4[beginIndex_2 + 3 | 0];
                // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
                // Inline function 'kotlinx.io.and' call
                if (!((b3 & 192) === 128)) {
                  // Inline function 'kotlinx.io.internal.processUtf16Chars.<anonymous>' call
                  if (!(65533 === 65533)) {
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_21 = length;
                    length = _unary__edvuaz_21 + 1 | 0;
                    chars[_unary__edvuaz_21] = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_22 = length;
                    length = _unary__edvuaz_22 + 1 | 0;
                    chars[_unary__edvuaz_22] = numberToChar((65533 & 1023) + 56320 | 0);
                  } else {
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_23 = length;
                    length = _unary__edvuaz_23 + 1 | 0;
                    chars[_unary__edvuaz_23] = _Char___init__impl__6a9atx(65533);
                  }
                  tmp$ret$15 = 3;
                  break $l$block_10;
                }
                var codePoint_1 = 3678080 ^ b3 ^ b2_0 << 6 ^ b1_1 << 12 ^ b0_2 << 18;
                if (codePoint_1 > 1114111) {
                  // Inline function 'kotlinx.io.internal.processUtf16Chars.<anonymous>' call
                  if (!(65533 === 65533)) {
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_24 = length;
                    length = _unary__edvuaz_24 + 1 | 0;
                    chars[_unary__edvuaz_24] = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_25 = length;
                    length = _unary__edvuaz_25 + 1 | 0;
                    chars[_unary__edvuaz_25] = numberToChar((65533 & 1023) + 56320 | 0);
                  } else {
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_26 = length;
                    length = _unary__edvuaz_26 + 1 | 0;
                    chars[_unary__edvuaz_26] = _Char___init__impl__6a9atx(65533);
                  }
                } else if (55296 <= codePoint_1 ? codePoint_1 <= 57343 : false) {
                  // Inline function 'kotlinx.io.internal.processUtf16Chars.<anonymous>' call
                  if (!(65533 === 65533)) {
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_27 = length;
                    length = _unary__edvuaz_27 + 1 | 0;
                    chars[_unary__edvuaz_27] = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_28 = length;
                    length = _unary__edvuaz_28 + 1 | 0;
                    chars[_unary__edvuaz_28] = numberToChar((65533 & 1023) + 56320 | 0);
                  } else {
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_29 = length;
                    length = _unary__edvuaz_29 + 1 | 0;
                    chars[_unary__edvuaz_29] = _Char___init__impl__6a9atx(65533);
                  }
                } else if (codePoint_1 < 65536) {
                  // Inline function 'kotlinx.io.internal.processUtf16Chars.<anonymous>' call
                  if (!(65533 === 65533)) {
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_30 = length;
                    length = _unary__edvuaz_30 + 1 | 0;
                    chars[_unary__edvuaz_30] = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_31 = length;
                    length = _unary__edvuaz_31 + 1 | 0;
                    chars[_unary__edvuaz_31] = numberToChar((65533 & 1023) + 56320 | 0);
                  } else {
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_32 = length;
                    length = _unary__edvuaz_32 + 1 | 0;
                    chars[_unary__edvuaz_32] = _Char___init__impl__6a9atx(65533);
                  }
                } else {
                  // Inline function 'kotlinx.io.internal.processUtf16Chars.<anonymous>' call
                  if (!(codePoint_1 === 65533)) {
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_33 = length;
                    length = _unary__edvuaz_33 + 1 | 0;
                    chars[_unary__edvuaz_33] = numberToChar((codePoint_1 >>> 10 | 0) + 55232 | 0);
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_34 = length;
                    length = _unary__edvuaz_34 + 1 | 0;
                    chars[_unary__edvuaz_34] = numberToChar((codePoint_1 & 1023) + 56320 | 0);
                  } else {
                    // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
                    var _unary__edvuaz_35 = length;
                    length = _unary__edvuaz_35 + 1 | 0;
                    chars[_unary__edvuaz_35] = _Char___init__impl__6a9atx(65533);
                  }
                }
                tmp$ret$15 = 4;
              }
              index = tmp_2 + tmp$ret$15 | 0;
            } else {
              // Inline function 'kotlinx.io.internal.commonToUtf8String.<anonymous>' call
              var _unary__edvuaz_36 = length;
              length = _unary__edvuaz_36 + 1 | 0;
              chars[_unary__edvuaz_36] = _Char___init__impl__6a9atx(65533);
              index = index + 1 | 0;
            }
          }
        }
      }
    }
    return concatToString(chars, 0, length);
  }
  function get_SegmentReadContextImpl() {
    _init_properties_UnsafeBufferOperations_kt__xw75gy();
    return SegmentReadContextImpl;
  }
  var SegmentReadContextImpl;
  function get_SegmentWriteContextImpl() {
    _init_properties_UnsafeBufferOperations_kt__xw75gy();
    return SegmentWriteContextImpl;
  }
  var SegmentWriteContextImpl;
  var BufferIterationContextImpl;
  function UnsafeBufferOperations() {
  }
  var UnsafeBufferOperations_instance;
  function UnsafeBufferOperations_getInstance() {
    return UnsafeBufferOperations_instance;
  }
  function SegmentReadContextImpl$1() {
  }
  protoOf(SegmentReadContextImpl$1).v4v = function (segment, offset) {
    return segment.o4w(offset);
  };
  function SegmentWriteContextImpl$1() {
  }
  protoOf(SegmentWriteContextImpl$1).w4w = function (segment, offset, value) {
    segment.p4w(offset, value);
  };
  protoOf(SegmentWriteContextImpl$1).v4w = function (segment, offset, b0, b1) {
    segment.q4w(offset, b0, b1);
  };
  protoOf(SegmentWriteContextImpl$1).u4w = function (segment, offset, b0, b1, b2) {
    segment.r4w(offset, b0, b1, b2);
  };
  protoOf(SegmentWriteContextImpl$1).t4w = function (segment, offset, b0, b1, b2, b3) {
    segment.s4w(offset, b0, b1, b2, b3);
  };
  function BufferIterationContextImpl$1() {
  }
  protoOf(BufferIterationContextImpl$1).v4v = function (segment, offset) {
    return get_SegmentReadContextImpl().v4v(segment, offset);
  };
  var properties_initialized_UnsafeBufferOperations_kt_2xfgoc;
  function _init_properties_UnsafeBufferOperations_kt__xw75gy() {
    if (!properties_initialized_UnsafeBufferOperations_kt_2xfgoc) {
      properties_initialized_UnsafeBufferOperations_kt_2xfgoc = true;
      SegmentReadContextImpl = new SegmentReadContextImpl$1();
      SegmentWriteContextImpl = new SegmentWriteContextImpl$1();
      BufferIterationContextImpl = new BufferIterationContextImpl$1();
    }
  }
  function IOException_init_$Init$($this) {
    Exception_init_$Init$($this);
    IOException.call($this);
    return $this;
  }
  function IOException_init_$Create$() {
    var tmp = IOException_init_$Init$(objectCreate(protoOf(IOException)));
    captureStack(tmp, IOException_init_$Create$);
    return tmp;
  }
  function IOException_init_$Init$_0(message, $this) {
    Exception_init_$Init$_0(message, $this);
    IOException.call($this);
    return $this;
  }
  function IOException_init_$Create$_0(message) {
    var tmp = IOException_init_$Init$_0(message, objectCreate(protoOf(IOException)));
    captureStack(tmp, IOException_init_$Create$_0);
    return tmp;
  }
  function IOException_init_$Init$_1(message, cause, $this) {
    Exception_init_$Init$_1(message, cause, $this);
    IOException.call($this);
    return $this;
  }
  function IOException_init_$Create$_1(message, cause) {
    var tmp = IOException_init_$Init$_1(message, cause, objectCreate(protoOf(IOException)));
    captureStack(tmp, IOException_init_$Create$_1);
    return tmp;
  }
  function IOException() {
    captureStack(this, IOException);
  }
  function EOFException_init_$Init$($this) {
    IOException_init_$Init$($this);
    EOFException.call($this);
    return $this;
  }
  function EOFException_init_$Create$() {
    var tmp = EOFException_init_$Init$(objectCreate(protoOf(EOFException)));
    captureStack(tmp, EOFException_init_$Create$);
    return tmp;
  }
  function EOFException_init_$Init$_0(message, $this) {
    IOException_init_$Init$_0(message, $this);
    EOFException.call($this);
    return $this;
  }
  function EOFException_init_$Create$_0(message) {
    var tmp = EOFException_init_$Init$_0(message, objectCreate(protoOf(EOFException)));
    captureStack(tmp, EOFException_init_$Create$_0);
    return tmp;
  }
  function EOFException() {
    captureStack(this, EOFException);
  }
  function SegmentPool() {
    this.e4v_1 = 0;
    this.f4v_1 = 0;
  }
  protoOf(SegmentPool).g4v = function () {
    return Companion_instance.j4w();
  };
  protoOf(SegmentPool).w4v = function (segment) {
  };
  protoOf(SegmentPool).l4w = function () {
    return AlwaysSharedCopyTracker_getInstance();
  };
  var SegmentPool_instance;
  function SegmentPool_getInstance() {
    return SegmentPool_instance;
  }
  //region block: post-declaration
  protoOf(Buffer).k4v = write$default;
  //endregion
  //region block: init
  Companion_instance = new Companion();
  UnsafeBufferOperations_instance = new UnsafeBufferOperations();
  SegmentPool_instance = new SegmentPool();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = EOFException_init_$Create$_0;
  _.$_$.b = IOException_init_$Init$_0;
  _.$_$.c = IOException_init_$Create$_0;
  _.$_$.d = IOException_init_$Create$_1;
  _.$_$.e = Buffer;
  _.$_$.f = IOException;
  _.$_$.g = Source;
  _.$_$.h = readByteArray_0;
  _.$_$.i = readByteArray;
  _.$_$.j = readString;
  _.$_$.k = readString_0;
  _.$_$.l = writeString;
  //endregion
  return _;
}));
